import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
// @material-ui/icons
import Search from "@material-ui/icons/Search";
// core components
import CustomInput from "../CustomInput/CustomInput.js";
import Button from "../CustomButtons/Button.js";
import styles from "../../layout/material-dashboard-react/components/headerLinksStyle.js";
import { Link } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import DirectionsBoatFilledOutlinedIcon from '@mui/icons-material/DirectionsBoatFilledOutlined';
import FlightIcon from '@mui/icons-material/Flight';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import axios from 'axios';
import useWindowSize from "app/hooks/useWindowSize.js";
import { LoginStatusContext } from "app/context/LoginStatusContext";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
    const classes = useStyles();
    const [openNotification, setOpenNotification] = useState(null);
    const [openProfile, setOpenProfile] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [searchResults, setSearchResults] = useState([{ ID: '0', Reference: 'Searching', DateAdded: '', ResultType: '' }]);
    const [openSearch, setOpenSearch] = useState(null);
    const { isLoggedIn } = useContext(LoginStatusContext);

    const windowSize = useWindowSize();

    const handleClickNotification = (event) => {
        if (notifications.length > 0) {
            if(openNotification && openNotification.contains(event.target)) {
                setOpenNotification(null);
            } else {
                setOpenNotification(event.currentTarget);
            }
        }
    };
    const handleCloseNotification = () => {
        setOpenNotification(null);
    };

    const getIcon = (bookingTypeId) => {
        switch (bookingTypeId) {
            case 17:
                return <FlightIcon sx={{ fontSize: 50, color: 'white' }} />
            case 18:
                return <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            case 19:
                return <FlightIcon sx={{ fontSize: 50, color: 'white' }} />
            case 20:
                return <DirectionsBoatFilledOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            case 100:
                return <SailingOutlinedIcon sx={{ fontSize: 50, color: 'white' }} />
            default:
        }
    }

    const getRef = (notification) => {
        switch (notification.bookingTypeId) {
            case 17:
            case 18:
                sessionStorage.setItem('ShipmentID', notification.referenceId);
                return window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + notification.referenceId;
            case 19:
            case 20:
                sessionStorage.setItem('ShipmentID', notification.referenceId);
                return window.location.href = '/LeoSeaPortal/quotedetails?shipmentId=' + notification.referenceId;
            default:
        }
    }

    const handleClickSearch = (event) => {
        if (openSearch && openSearch.contains(event.target)) {
            setOpenSearch(null);
        } else {
            setOpenSearch(event.currentTarget);
        }
    };

    const handleCloseSearch = () => {
        setOpenSearch(null)
    }

    const handleOnClickSearch = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        const formData = new FormData(form);

        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/search`,
                formDataJsonString
            )
            .then(function (response) {
                setSearchResults(response.data)
            })
            .catch(function (error) {
                console.log("Search results failed " + error);
            });
    };

    const renderTable = (searchResults) => {

        const handleChange = (ID, ResultType) => e => {
            if (ID !== 0) {
                if (ResultType === 'Quote') {
                    window.location.href = '/LeoSeaPortal/quotedetails?shipmentId=' + ID + '';
                }
                if (ResultType === 'Booking') {
                    window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + ID + '';
                }
            }
        };

        return (<table className='table' id="search" aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>Reference</th>
                    <th>Result Type</th>
                    <th>Date Added</th>
                </tr>
            </thead>
            <tbody>
                {searchResults.map(item =>
                    <tr className="searchRow" key={item.ID} onClick={handleChange(item.ID, item.ResultType)} >
                        <td>{item.Reference}</td>
                        <td>{item.ResultType}</td>
                        <td>{item.DateAdded}</td>
                    </tr>
                )}
            </tbody>
        </table>);
    }

    const handleClickProfile = (event) => {
        if (openProfile && openProfile.contains(event.target)) {
            setOpenProfile(null);
        } else {
            setOpenProfile(event.currentTarget);
        }
    };
    const handleCloseProfile = () => {
        setOpenProfile(null);
    };

    function onMouseOverReference(e) {
        e.target.style.textDecorationLine = 'underline';
    }

    function onMouseOutReference(e) {
        e.target.style.textDecorationLine = 'none';
    }

    useEffect(() => {
        //get notifications
        if (isLoggedIn) {
            getNotifications();
        }

        //then get notifications every 30 seconds
        const interval = setInterval(() => {
            if (isLoggedIn) {
                getNotifications();
            }
        }, 30000);
        return () => clearInterval(interval);

        async function getNotifications() {
            return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/notification/GetNotifications`)
                .then((response) => {
                    setNotifications(response.data);
                    sessionStorage.setItem('NotificationsCount', response.data.length);
                });
        }

    }, [isLoggedIn]);

    let contents = renderTable(searchResults);

    return (
        <div>
            <div className={classes.searchWrapper}>
                <form onSubmit={handleOnClickSearch}>
                    <CustomInput
                        id="searchInput"
                        name="searchInput"
                        type="text"
                        formControlProps={{
                            className: classes.margin + " " + classes.search,
                        }}
                        inputProps={{
                            placeholder: "Search",
                            'data-testid': "headerSearchInput",
                            inputProps: {
                                "aria-label": "Search",
                            },
                        }}
                    />
                    <Button color="white"
                        aria-label="edit"
                        aria-owns={openSearch ? "search-menu-list-grow" : null}
                        aria-haspopup="true"
                        data-testid="headerSearchButton"
                        onClick={handleClickSearch}
                        justIcon round type="submit">
                        <Search />
                    </Button>
                </form>
                <Poppers
                    open={Boolean(openSearch)}
                    anchorEl={openSearch}
                    transition
                    disablePortal
                    className={
                        classNames({ [classes.popperClose]: !openSearch }) +
                        " " +
                        classes.popperNav
                    }
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            id="search-menu-list-grow"
                            style={{
                                transformOrigin:
                                    placement === "bottom" ? "center top" : "center bottom",
                                maxHeight: windowSize.height - 150,
                                minWidth: "300px",
                                overflowY: 'scroll',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleCloseSearch}>
                                    {contents}
                                </ClickAwayListener>
                            </Paper>

                        </Grow>
                    )}
                </Poppers>
            </div>
            <Link className={classes.buttonLink} to="/LeoSeaPortal/dashboard">
                <Button
                    color={window.innerWidth > 959 ? "transparent" : "white"}
                    justIcon={window.innerWidth > 959}
                    simple={!(window.innerWidth > 959)}
                    aria-label="Dashboard"
                    data-testid="headerHomeButton"
                    className={classes.buttonLink}
                >
                    <HomeOutlinedIcon className={classes.icons} />
                    <Hidden mdUp implementation="css">
                        <p className={classes.linkText}>Dashboard</p>
                    </Hidden>
                </Button>
            </Link>
            <div className={classes.manager}>
                <Button
                    color={window.innerWidth > 959 ? "transparent" : "white"}
                    justIcon={window.innerWidth > 959}
                    simple={!(window.innerWidth > 959)}
                    aria-owns={openNotification ? "notification-menu-list-grow" : null}
                    aria-haspopup="true"
                    data-testid="headerNotificationButton"
                    onClick={handleClickNotification}
                    className={classes.buttonLink}
                >
                    <NotificationsActiveOutlinedIcon className={classes.icons} />
                    {notifications.length > 0 && (<span className={classes.notifications}>{notifications.length}</span>)}
                    <Hidden mdUp implementation="css">
                        <p onClick={handleCloseNotification} className={classes.linkText}>
                            Notification
                        </p>
                    </Hidden>
                </Button>
                <Poppers
                    open={Boolean(openNotification)}
                    anchorEl={openNotification}
                    transition
                    disablePortal
                    className={
                        classNames({ [classes.popperClose]: !openNotification }) +
                        " " +
                        classes.popperNav
                    }
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            id="notification-menu-list-grow"
                            style={{
                                transformOrigin:
                                    placement === "bottom" ? "center top" : "center bottom",
                                maxHeight: "600px",
                                overflowY: 'scroll',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleCloseNotification}>
                                    <MenuList role="menu">
                                        {notifications.map(notification =>
                                            <><MenuItem className={classes.dropdownItem}
                                                style={{ backgroundColor: notification.notificationColour }}>
                                                <div style={{ display: 'flex' }} class="row">
                                                    <div class="column">
                                                        <td style={{
                                                            textDecoration: 'none', zIndex: '-1', width: '1px',
                                                            height: '1px', backgroundColor: notification.notificationColour
                                                        }}
                                                        >{getIcon(notification.bookingTypeId)}</td>
                                                    </div>
                                                    <div class="column">
                                                        <div>{notification.title}</div>
                                                        <div>{notification.message}</div>
                                                        <div style={{ cursor: 'pointer' }} onMouseOver={onMouseOverReference} onMouseOut={onMouseOutReference} onClick={() => getRef(notification)}>{notification.reference}</div>
                                                    </div>
                                                </div>
                                            </MenuItem>
                                                <Divider style={{ height: 8, background: '#FFFFFF' }} /></>
                                        )}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Poppers>
            </div>
            <div className={classes.manager}>
                <Button
                    color={window.innerWidth > 959 ? "transparent" : "white"}
                    justIcon={window.innerWidth > 959}
                    simple={!(window.innerWidth > 959)}
                    aria-owns={openProfile ? "profile-menu-list-grow" : null}
                    aria-haspopup="true"
                    data-testid="headerProfileButton"
                    onClick={handleClickProfile}
                    className={classes.buttonLink}
                >
                    <AccountCircleOutlinedIcon className={classes.icons} />
                    <Hidden mdUp implementation="css">
                        <p className={classes.linkText}>Profile</p>
                    </Hidden>
                </Button>
                <Poppers
                    open={Boolean(openProfile)}
                    anchorEl={openProfile}
                    transition
                    disablePortal
                    className={
                        classNames({ [classes.popperClose]: !openProfile }) +
                        " " +
                        classes.popperNav
                    }
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            id="profile-menu-list-grow"
                            style={{
                                transformOrigin:
                                    placement === "bottom" ? "center top" : "center bottom",
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleCloseProfile}>
                                    <MenuList role="menu">
                                        <Link className={classes.buttonLink} to="/LeoSeaPortal/notificationsettings">
                                            <MenuItem
                                                data-testid="headerUserDropDownNotificationSettings"
                                                onClick={handleCloseProfile}
                                                className={classes.dropdownItem}
                                            >
                                                Notification Settings
                                            </MenuItem>
                                        </Link>
                                        <Divider light />
                                        <Link className={classes.buttonLink} to="/LeoSeaPortal/logout">
                                            <MenuItem
                                                data-testid="headerUserDropDownLogout"
                                                onClick={handleCloseProfile}
                                                className={classes.dropdownItem}
                                            >
                                                Logout
                                            </MenuItem>
                                        </Link>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Poppers>
            </div>
        </div>
    );
}
